import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputDailyTimeTargets } from './InputDailyTimeTargets.entity';
import { InputUserAssignedLicense } from './InputUserAssignedLicense.entity';
import { InputUserSyncOptionsRelation } from './InputUserSyncOptionsRelation.entity';

export class InputFullUserRelation<T extends EMode = EMode.entity> {
  /** Alias: dailyTimeTargets */
  dailyTimeTargets?: InputDailyTimeTargets<T>;
  /** Alias: syncOptions */
  syncOptions?: InputUserSyncOptionsRelation<T>;
  /** Alias: userImageFromTempFile */
  userImageFromTempFile?: string;
  /** Alias: setUserAssignedLicense */
  setUserAssignedLicense?: InputUserAssignedLicense<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputFullUserRelation> = {
  dailyTimeTargets: {
    alias: 'dailyTimeTargets',
  },
  syncOptions: {
    alias: 'syncOptions',
  },
  userImageFromTempFile: {
    alias: 'userImageFromTempFile',
  },
  setUserAssignedLicense: {
    alias: 'setUserAssignedLicense',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputFullUserRelationEntityDefinition: EntitiyDefinition<InputFullUserRelation> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputFullUserRelation',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
